import { Component, OnInit } from '@angular/core';
import { AdminServices, GlobalService } from '@app/services';
import moment from 'moment';
@Component({
    selector: 'app-binnacle',
    templateUrl: './binnacle.component.html',
    styleUrls: ['./binnacle.component.scss'],
    standalone: false
})
export class BinnacleComponent implements OnInit {
  partners:Array<any> = []
  actions:Array<any> = []
  urlsRequested:Array<any> = [];
  currentPosition:number = 0;
  totalPages:number = 0;
  partnerCode:any = null
  rowsRecived:Array<any> = []
  historicalData:Array<object> = []
  actionSelected:any = null;
  dateSelected:any = {
    "from": null,
    "to": null
  }
  userName:any = null;
  contractNumberCaptured:any = null
  constructor(
    private adminServices: AdminServices,
    private globalServices: GlobalService
  ) {
    this.adminServices.getAllProviders().subscribe((response)=>{
      if(!response.error){
        response.data.forEach((element: any) => {
          if(element.is_active){
            let productTypeName = ''
            switch(element.product_type){
              case 1:
                productTypeName = 'mca'
                break;
              case 2:
                productTypeName = 'factoring'
                break;
              case 3:
                productTypeName = 'discount f.'
                break;
              case 7:
                productTypeName = 'simple credit'
                break;
            }
            element['name_product_format'] = `${element.name} - ${productTypeName}`
            this.partners.push(element);
          }
        });
      }
    });
    this.adminServices.getHistoricalUsersActions().subscribe((response:any)=>{
      if(!response.error){
        this.actions = response.data
      }
    })
    
  }

  ngOnInit(): void {
  }

  moveIntoPages(currentUrl:string){  
    this.adminServices.getHistoricalUsersRecords(currentUrl, null, null, null, null, null, null, null, null).subscribe((response)=>{
      if (!response.error) {
        if (response.data) {
          if (response.data.length > 0) {
            response.data.forEach((item:any) => {
              item.contract_number =item.contract_number ? item.contract_number : 'N/A' 
              item.created_at = moment(item.created_at).format('YYYY-MM-DD')
            });
            this.rowsRecived = response.data;
            this.historicalData = response;
          } else {
            alert('No se encontro informacion')
          }
        } else {
          alert('No se encontro data')
        }
      }
    });
  }

  search() {
    this.rowsRecived = [];
    this.urlsRequested = [];
    this.currentPosition = 0


    let dateFrom = null
    if (this.dateSelected.from) {
      dateFrom =  moment(this.dateSelected.from).format('YYYY-MM-DD')
    }

    let dateTo = null
    if (this.dateSelected.to) {
      dateTo = moment(this.dateSelected.to).format('YYYY-MM-DD')
    }

    if(this.contractNumberCaptured && !this.partnerCode){
      this.globalServices.prepareAlert({ title: "Error", message: "Debe seleccionar un partner", label: "error" })
        .subscribe((result) => {
        });
      return;
    }

    if (dateTo && dateFrom) {
      this.adminServices.getHistoricalUsersRecords('', 10, 0, dateFrom, dateTo, this.userName, this.partnerCode, this.actionSelected, this.contractNumberCaptured).subscribe((response) => {
        if (!response.error) {
          if (response.data) {
            if (response.data.length > 0) {
              this.totalPages = response.meta.page;
              response.data.forEach((item: any) => {
                item.contract_number = item.contract_number ? item.contract_number : 'N/A'
                item.created_at = moment(item.created_at).format('YYYY-MM-DD')
              });
              this.rowsRecived = response.data;
               this.historicalData = response;
            } else {
              alert('No se encontro informacion');
            }
          } else {
            alert('No se encontro informacion')
          }

        }else{
          this.globalServices.prepareAlert({ title: "Error", message: response.message, label: "error" })
        .subscribe((result) => {
        });
        }
      });
    } else {
      this.globalServices.prepareAlert({ title: "Error", message: "Debe seleccionar fechas", label: "error" })
        .subscribe((result) => {
        });
    }
  }

  cleanSearch(){
    this.rowsRecived = [];
    this.urlsRequested = [];
    this.currentPosition = 0
    this.actionSelected = null
    this.partnerCode = null
    this.userName = null;
    this.dateSelected.from = null
    this.dateSelected.to  = null
  }



}
